/**
 * @owner @Appboy/user-targeting
 */
import type { AllRouteEndpoints } from "../routeTypes";

export const apiEcommerceRecommendedEvents = "/api/ecommerce/recommended_events";

export const apiEcommerceRecommendedEventsCacheKeys: AllRouteEndpoints[] = ["/api/ecommerce/recommended_events"];
